import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { withMediaAnalyticsContext } from '@atlaskit/media-common';
import isValidId from 'uuid-validate';
import { LocalUploadComponentReact } from '../localUploadReact';
import { getPackageAttributes } from '../../util/analytics';
import UploadRejectionFlagGroup from '../uploadRejectionFlagGroup/UploadRejectionFlagGroup';
var defaultConfig = {
  uploadParams: {}
};
var COMPONENT_NAME = 'browser';
export var BrowserBase = /*#__PURE__*/function (_LocalUploadComponent) {
  _inherits(BrowserBase, _LocalUploadComponent);
  var _super = _createSuper(BrowserBase);
  function BrowserBase(props) {
    var _this;
    _classCallCheck(this, BrowserBase);
    _this = _super.call(this, props, COMPONENT_NAME);
    _defineProperty(_assertThisInitialized(_this), "browserRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "onFilePicked", function (event) {
      if (!event.target) {
        return;
      }
      var replaceFileId = _this.props.config.replaceFileId;
      var filesArray = [].slice.call(event.target.files);

      // refreshes uploadParams as only set once in parent constructor
      _this.setUploadParams(_this.props.config.uploadParams);
      try {
        if (replaceFileId) {
          _this.uploadService.addFile(filesArray[0], replaceFileId);
        } else {
          _this.uploadService.addFiles(filesArray);
        }
      } finally {
        if (_this.browserRef.current) {
          _this.browserRef.current.value = '';
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "browse", function () {
      var onClose = _this.props.onClose;
      if (!_this.browserRef.current) {
        return;
      }
      _this.browserRef.current.click();
      // Calling onClose directly since there is no dom api to notify us when
      // the native file picker is closed
      if (onClose) {
        onClose();
      }
    });
    var config = props.config,
      onError = props.onError;
    var _replaceFileId = config.replaceFileId;
    if (_replaceFileId && !isValidId(_replaceFileId)) {
      _this.createAndFireAnalyticsEvent({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaUpload',
        actionSubjectId: 'localMedia',
        attributes: {
          status: 'fail',
          failReason: 'invalid_uuid',
          uuid: _replaceFileId
        }
      });
      onError && onError({
        fileId: _replaceFileId,
        error: {
          description: 'Invalid replaceFileId format',
          name: 'invalid_uuid',
          fileId: _replaceFileId
        }
      });
    }
    return _this;
  }
  _createClass(BrowserBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        onBrowseFn = _this$props.onBrowseFn,
        onCancelFn = _this$props.onCancelFn,
        isOpen = _this$props.isOpen;
      if (onBrowseFn) {
        onBrowseFn(this.browse);
      }
      if (onCancelFn) {
        onCancelFn(this.cancel);
      }
      if (isOpen) {
        this.browse();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isOpen = this.props.isOpen;
      var nextIsOpen = nextProps.isOpen;
      if (nextIsOpen && nextIsOpen !== isOpen) {
        this.browse();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        config = _this$props2.config,
        children = _this$props2.children;
      var multiple = config.multiple,
        replaceFileId = config.replaceFileId;
      var fileExtensions = config.fileExtensions && config.fileExtensions.join(',');
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
        "data-testid": "media-picker-file-input",
        ref: this.browserRef,
        type: "file",
        style: {
          display: 'none'
        },
        multiple: replaceFileId ? false : multiple /* if the consumer passes the fileId we must work in single selection mode */,

        accept: fileExtensions,
        onChange: this.onFilePicked
      }), children ? children(this.browse) : null, /*#__PURE__*/React.createElement(UploadRejectionFlagGroup, {
        flagData: this.state.uploadRejectionFlags,
        onFlagDismissed: this.dismissUploadRejectionFlag
      }));
    }
  }]);
  return BrowserBase;
}(LocalUploadComponentReact);
_defineProperty(BrowserBase, "defaultProps", {
  config: defaultConfig
});
export default BrowserBase;
export var Browser = withMediaAnalyticsContext(getPackageAttributes(COMPONENT_NAME))(withAnalyticsEvents()(BrowserBase));